import { api } from './client.js';

const root = '/kiosk';

export const kioskApi = {
  grant: (body) => api.post(`${root}/consent`, body),
  status: (sid) => api.get(`${root}/consent/${sid}`),
  revoke: (sid, reason) => api.post(`${root}/consent/revoke`, { customerSessionId: sid, reason })
};
